import { useEffect, useRef } from "react";
import { usePitchDetector } from "./usePitchDetector";
import { GYM_AUDIO_HOLD_MS } from "../lib/gym/gymTiming";
import type { NoteName } from "../lib/guitarEngine";

export interface UseGymAudioListenerOptions {
  enabled: boolean;
  onStableNote: (note: NoteName, octave: number, frequency: number) => void;
}

/**
 * Escucha el micrófono mientras el ejercicio está activo y emite notas estables.
 */
export function useGymAudioListener({ enabled, onStableNote }: UseGymAudioListenerOptions) {
  const onStableRef = useRef(onStableNote);
  onStableRef.current = onStableNote;

  const { state, startListening, stopListening } = usePitchDetector({
    holdTimeMs: GYM_AUDIO_HOLD_MS,
    threshold: 0.0035,
    onNoteStable: (note, octave, frequency) => {
      onStableRef.current(note, octave, frequency);
    },
  });

  useEffect(() => {
    if (!enabled) {
      stopListening();
      return;
    }
    void startListening();
    return () => stopListening();
  }, [enabled, startListening, stopListening]);

  return { isListening: state.isListening, volume: state.volume, holdProgress: state.holdProgress };
}
